import { useEffect, useState } from 'react';

import deviceSizes from 'assets/scss/sizes.module.scss';

const useSize = () => {
  const [sizes, setSizes] = useState(getSizes());

  useEffect(() => {
    const checkMobile = () => {
      setSizes(getSizes());
    };

    let timeoutId: NodeJS.Timeout;

    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(checkMobile, 100);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(timeoutId);
    };
  }, []);

  return { ...sizes };
};

function getSizes() {
  const isWindow = typeof window !== 'undefined';
  const desktop = deviceSizes.desktop.slice(0, -2);
  const landscapeTablet = deviceSizes.landscape_tablet.slice(0, -2);
  const tablet = deviceSizes.tablet.slice(0, -2);
  const mobile = deviceSizes.mobile.slice(0, -2);

  return {
    width: window.innerWidth,

    isMobile: isWindow ? window.innerWidth <= Number(mobile) : null,
    isTablet:
      (isWindow ? window.innerWidth <= Number(tablet) : null) &&
      (isWindow ? window.innerWidth > Number(mobile) : null),
    isLandscapeTablet:
      (isWindow ? window.innerWidth <= Number(landscapeTablet) : null) &&
      (isWindow ? window.innerWidth > Number(tablet) : null),
    isDesktop: isWindow
      ? window.innerWidth >= Number(desktop) &&
        (isWindow ? window.innerWidth < 1920 : null)
      : null,
    isFullHD: isWindow ? window.innerWidth >= 1920 : null,

    isMoreThanLandscape: isWindow
      ? window.innerWidth > Number(landscapeTablet)
      : null,
    isMoreThanTablet: isWindow ? window.innerWidth > Number(tablet) : null,
    isMoreThanMobile: isWindow ? window.innerWidth > Number(mobile) : null,

    isLessThanTablet: isWindow ? window.innerWidth < Number(tablet) : null,
    isLessThanLandscape: isWindow
      ? window.innerWidth < Number(landscapeTablet)
      : null,
    isLessThanDesktop: isWindow ? window.innerWidth < Number(desktop) : null,
  };
}

export default useSize;
